// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2nax6","colMin":"styles_colMin__1KDl_","colCheckbox":"styles_colCheckbox__3oZXZ"};